import { ReconBankPage } from "@/features/recon-bank/pages/ReconBankPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recon-bank/")({
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["recon_bank.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ReconBankPage,
});
